import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCheckCircle, FaClock, FaRupeeSign, FaUserGraduate, FaFlask, FaIndustry, FaMicroscope } from "react-icons/fa";
import { MdHealthAndSafety } from "react-icons/md";
const GNMCoursePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <nav className="flex text-sm text-gray-500">
            <Link to="/" className="hover:text-blue-600">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/courses" className="hover:text-blue-600">Courses</Link>
            <span className="mx-2">/</span>
            <span className="text-green-600 font-semibold">GNM</span>
          </nav>
        </div>
        <div className="bg-gradient-to-r from-green-600 to-green-500 rounded-3xl p-8 mb-8 text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-32 translate-x-32"></div>
          <div className="relative flex items-center gap-4">
            <div className="bg-white/30 p-4 rounded-2xl backdrop-blur-sm">
              <MdHealthAndSafety className="text-5xl" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-2">GNM Course</h1>
              <p className="text-xl text-white/90">General Nursing and Midwifery</p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-8">
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">About the Course</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                GNM (General Nursing and Midwifery) is a diploma course that prepares students to become professional nurses who can work in hospitals, nursing homes, and community health settings. The program covers all aspects of nursing care, including medical-surgical nursing, pediatric nursing, psychiatric nursing, and midwifery.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Students receive comprehensive training in patient care, medication administration, wound care, and emergency management, along with specialized training in midwifery and obstetric care.
              </p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Career Opportunities in Pharmacy</h2>
              <div className="space-y-4">
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-4 rounded-xl">
                  <div className="flex items-start gap-4">
                    <div className="bg-blue-100 p-3 rounded-lg">
                      <FaFlask className="text-xl text-blue-600" />
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800 mb-1">Career in Pharmacy</p>
                      <p className="text-sm text-gray-600">Clinical, Retail, Hospital Pharmacy</p>
                      <p className="text-xs text-gray-500 mt-2">Opportunities: Community Pharmacist, Clinical Pharmacist, Hospital Pharmacist</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-green-50 to-blue-50 p-4 rounded-xl">
                  <div className="flex items-start gap-4">
                    <div className="bg-green-100 p-3 rounded-lg">
                      <FaIndustry className="text-xl text-green-600" />
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800 mb-1">Production & Manufacturing</p>
                      <p className="text-sm text-gray-600">Quality Control, Production Management</p>
                      <p className="text-xs text-gray-500 mt-2">Opportunities: Production Officer, Quality Analyst, Plant Supervisor</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-4 rounded-xl">
                  <div className="flex items-start gap-4">
                    <div className="bg-purple-100 p-3 rounded-lg">
                      <FaMicroscope className="text-xl text-purple-600" />
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800 mb-1">Research & Development</p>
                      <p className="text-sm text-gray-600">Drug Discovery, Clinical Research</p>
                      <p className="text-xs text-gray-500 mt-2">Opportunities: Research Scientist, Clinical Research Associate</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Additional Career Options</h2>
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-gray-50 p-3 rounded-lg text-center">
                  <p className="font-semibold text-gray-700">Clinical Research</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg text-center">
                  <p className="font-semibold text-gray-700">Hospital Admin</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg text-center">
                  <p className="font-semibold text-gray-700">Quality Assurance</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg text-center">
                  <p className="font-semibold text-gray-700">Regulatory Affairs</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Primary Career Paths</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="bg-green-50 p-4 rounded-xl text-center">
                  <p className="font-semibold text-green-700">Multi-speciality Hospitals</p>
                </div>
                <div className="bg-green-50 p-4 rounded-xl text-center">
                  <p className="font-semibold text-green-700">Pharma Companies</p>
                </div>
                <div className="bg-green-50 p-4 rounded-xl text-center">
                  <p className="font-semibold text-green-700">Research Labs</p>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-2xl shadow-lg sticky top-24">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Course Information</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FaClock className="text-green-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Duration</p>
                    <p className="font-semibold text-gray-800">3Years</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FaUserGraduate className="text-green-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Eligibility</p>
                    <p className="font-semibold text-gray-800">10+2 (Any Stream)</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FaRupeeSign className="text-green-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Course Fees</p>
                    <p className="font-semibold text-gray-800">₹90,000per year</p>
                  </div>
                </div>
              </div>
              <div className="border-t border-gray-200 my-6"></div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Admission Details</h3>
              <div className="space-y-3">
                <p className="text-sm text-gray-600">📅 Admission Start: <span className="font-semibold">12th June 2025</span></p>
                <p className="text-sm text-gray-600">🎯 Total Seats: <span className="font-semibold">40</span></p>
                <p className="text-sm text-gray-600">📝 Mode: <span className="font-semibold">Merit Based</span></p>
              </div>
              <div className="mt-6 space-y-3">
                <Link
                  to="/admission"
                  className="block w-full py-3 px-4 bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-300 text-center"
                >
                  Apply Now <FaArrowRight className="inline ml-2" />
                </Link>
                <button className="w-full py-3 px-4 border-2 border-green-600 text-green-600 font-semibold rounded-xl hover:bg-green-50 transition-all duration-300">
                  Download Brochure
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GNMCoursePage;